import { createContext, useContext, useState } from "react"

export const DarkModeContext = createContext({
  isDarkMode: false,
  toggleDarkMode: () => {},
})

export const DarkModeProvider = DarkModeContext.Provider
export const useDarkMode = () => useContext(DarkModeContext)
